const guestModel = {
    guests: [
        {
            id: "guest1",
            name: "David Craig",
            image: "/images/reunion/guests/DavidCraigImage.jpg"
        },
        {
            id: "guest2",
            name: "Marcia Bradley",
            image: "/images/reunion/guests/MarciaBradley.jpg"
        },
        {
            id: "guest3",
            name: "Marcy Wilcox",
            image: "/images/reunion/guests/MarcyWilcox.jpg"
        },
        {
            id: "guest4",
            name: "Hayley Shen",
            image: "/images/reunion/guests/HayleyShen.JPG"
        },
        {
            id: "guest5",
            name: "Chris Robinson",
            image: "/images/reunion/guests/blank_profile.png"
        },
        {
            id: "guest6",
            name: "Jenny Townsend",
            image: "/images/reunion/guests/JenniferTownsend04.jpg"
        },
    ]
}

export default guestModel;

// format: id, name, image
// same as speakers
